import Landing from '../pages/landing';


const Home = () => {
    return (
        <Landing />
    )
}

export default Home;